<!-- 为了加全局manlength控制，其他的不一定能用 -->
<template>
  <o-input
    v-model="innerValue"
    @input="valueInput"
    @blur="valueBlur"
    v-on="$listeners"
    v-bind="$attrs"
    :type="type"
    :maxlength="
      maxlength
        ? maxlength
        : type === 'textarea'
        ? DESCRIPTION_MAX_LENGTH
        : type === 'integer' || type === 'decimal'
        ? NUMBER_INPUT_MAX_LENGTH
        : TITLE_MAX_LENGTH
    "
  >
    <template v-for="(item, key) in $slots" #[key]>
      <slot :name="key"></slot>
    </template>
  </o-input>
  <!-- <div>
    {{ type }}
    {{ maxlength }}
    <o-input
      v-model="innerValue"
      @input="valueInput"
      @blur="valueBlur"
      v-on="$listeners"
      v-bind="$attrs"
      :type="type"
      :maxlength="
        maxlength
          ? maxlength
          : type === 'textarea'
          ? DESCRIPTION_MAX_LENGTH
          : type === 'integer' || type === 'decimal'
          ? NUMBER_INPUT_MAX_LENGTH
          : TITLE_MAX_LENGTH
      "
    >
      <template v-for="(item, key) in $slots" #[key]>
        <slot :name="key"></slot>
      </template>
    </o-input>
  </div> -->
</template>

<script>
import { TITLE_MAX_LENGTH, DESCRIPTION_MAX_LENGTH, NUMBER_INPUT_MAX_LENGTH } from './baseConfig'

export default {
  name: 'ElInput',
  data() {
    return {
      innerValue: '',
      TITLE_MAX_LENGTH,
      DESCRIPTION_MAX_LENGTH,
      NUMBER_INPUT_MAX_LENGTH
    }
  },
  props: {
    value: [String, Number],
    type: [String, Number],
    maxlength: {
      default: 0
    },
    // 默认限制的小数位数为2
    decimalDigits: {
      default: 2
    }
  },
  methods: {
    valueInput(newVal) {
      // 1
      const fun = () => {
        if (this.maxlength) {
          return this.maxlength
        }
        if (this.type === 'textarea') {
          return DESCRIPTION_MAX_LENGTH
        }
        if (this.type === 'integer' || this.type === 'decimal') {
          return NUMBER_INPUT_MAX_LENGTH
        }
        return TITLE_MAX_LENGTH
      }
      const maxLength = fun()
      if (String(newVal).length === maxLength) {
        this.$Message.info(`输入内容长度已达上限：${maxLength}字`)
      }
      this.$emit('input', newVal)
    },
    valueBlur(e) {
      // 保留两位的小数输入，需要在输入过程中（input）以及输入完成之后（blur），使用不同的校验方式
      if (this.type === 'decimal') {
        const newVal = e.target.value
        this.innerValue = this.$limit.blurLimitPositiveDecimal(newVal, this.decimalDigits) || ''
      }
      this.$emit('input', this.innerValue)
    }
  },
  watch: {
    // v-model: value + @input 组合的语法糖
    value: {
      handler(newVal) {
        // 2
        let res = ''
        if (this.type === 'integer') {
          res = this.$limit.limitPositiveInteger(newVal)
        } else if (this.type === 'decimal') {
          res = this.$limit.limitPositiveDecimal(newVal, this.decimalDigits)
        } else {
          res = newVal
        }
        // 默认回显时展示数据
        if (res) {
          this.innerValue = res
        } else {
          // 当条件不符合时不仅修改页面展示值this.innerValue，同时置空一下value值，如果当出现输入多次同样value值，只更新this.innerValue值，会导致不能观察（watch）到第二次输入同样的value值
          this.innerValue = ''
          this.$emit('input', '')
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped></style>
